import React from "react";
import { track } from "@/lib/analytics";

const TABS = [
  { id: "focacce", label: "FOCACCE", sub: "IL CUORE DI UNGRIP", target: "menu" },
  { id: "dirty_sides", label: "DIRTY SIDES", sub: "SPORCATI LE MANI", target: "dirty-sides" },
  { id: "dolci", label: "DOLCI", sub: "FINISCI IN BELLEZZA", target: "dolci-drink" },
  { id: "drink", label: "DRINK", sub: "BEVI LA VOGLIA", target: "dolci-drink" },
];

function scrollTo(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

export default function CategoryTabs({ active, onChange }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
      {TABS.map((t) => {
        const isActive = active === t.id;
        return (
          <button
            key={t.id}
            onClick={() => {
              onChange(t.id);
              track("category_change", { category: t.id });
              scrollTo(t.target);
            }}
            className={`text-left rounded-xl px-4 py-3 border transition-colors duration-200 ${
              isActive
                ? "bg-[#FFC20E] border-[#FFC20E] text-[#0C0C0C]"
                : "bg-transparent border-[#333] text-white hover:border-[#FFC20E]/60"
            }`}
            data-testid={`category-tab-${t.id.replace("_", "-")}`}
          >
            <span className="block font-display font-black uppercase text-xl sm:text-2xl leading-none">{t.label}</span>
            <span className={`block text-[11px] font-semibold uppercase tracking-wide mt-1 ${isActive ? "text-[#0C0C0C]/70" : "text-white/50"}`}>
              {t.sub}
            </span>
          </button>
        );
      })}
    </div>
  );
}
